import type { JsonApiResponseSingle } from 'json-api-normalizer';

import api from 'api/apiInstance';

export function adviceRoomDocumentRevertApi(path: string) {
  return {
    path,
    DELETE: () => api.delete<JsonApiResponseSingle>(path),
  };
}
